import { LOAD_VIEW_ALL } from "./actions";

const initialState = {
  content: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOAD_VIEW_ALL:
      return { ...state, content: action.content };
    default:
      return state;
  }
};
